import asDescreteValueNegativeOneTOOne from "./asDescreteValueNegativeOneTOOne";

const dateComparator = (d1: Date, d2: Date) =>
  asDescreteValueNegativeOneTOOne(d1.getTime() - d2.getTime());

export default dateComparator;
